import React, { PropsWithChildren } from "react";
import { Modal } from "antd";
import { Button } from "./Button";
import { useMediaQuery } from "react-responsive";
import { DESKTOP_WIDTH } from "@bundles/consts";

type EditModalProps = {
  open?: boolean;
  onClose?: () => void;
  onSave?: () => void;
  title?: string;
  description?: string;
  customSaveBtnText?: string;
  isOnSaveDisabled?: boolean;
  successContent?: React.ReactNode;
  shouldDisplaySuccess?: boolean;
};

export const EditModal = ({
  open,
  onClose,
  onSave,
  title,
  description,
  isOnSaveDisabled,
  customSaveBtnText,
  successContent,
  shouldDisplaySuccess,
  children,
}: PropsWithChildren<EditModalProps>) => {
  const isMobile = useMediaQuery({ maxWidth: DESKTOP_WIDTH });

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={isMobile ? "100%" : "70%"}
      className="tailwind-modal"
    >
      {shouldDisplaySuccess && successContent}

      {!shouldDisplaySuccess && (
        <div className="lg:p-6">
          <div className="mb-[40px]">
            {title && <h2 className="text-xl font-semibold ">{title}</h2>}
            {description && <div>{description}</div>}
          </div>
          <div className="mb-[40px]">{children}</div>
          <div className="mt-6 flex flex-col items-center gap-2">
            <Button
              disabled={isOnSaveDisabled}
              isPrimary
              onClick={onSave}
              className="w-full bg-success"
            >
              {customSaveBtnText ?? "Save changes"}
            </Button>
            <button
              onClick={onClose}
              className="underline bg-transparent inline-block w-fit"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
};
